module.exports = __webpack_public_path__ + "static/project-7a-d6502d50792bf59499ddcbe39a03d30e.png";